import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import QrCodeDialog from "../../../Shared/Dialogs/QrCodeDialog";
import { QrCode as QrCodeIcon } from "lucide-react";
import Button from "../../../Shared/Buttons/Button";

function ApiMeasurementQrButton({ apiAction, apiName, qrUrl, disabled, borderRadius = 0, ...restProps }) {
  const [open, setOpen] = useState(false);

  const handleClickOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <>
      <Button variant="light" iconButton startIcon={<QrCodeIcon />} disabled={disabled} onClick={handleClickOpen} style={{ borderRadius }} {...restProps} />

      {open && (
        <QrCodeDialog
          open={open}
          onClose={handleClose}
          title={apiAction}
          qrValue={qrUrl}
          qrSize={240}
          printTitle={`${apiAction} (${apiName})`}
          width={400}
        />
      )}
    </>
  );
}

ApiMeasurementQrButton.propTypes = {
  apiAction: PropTypes.string,
  apiName: PropTypes.string,
  qrUrl: PropTypes.string,
  disabled: PropTypes.bool,
  borderRadius: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default ApiMeasurementQrButton;
